/**
 * @method getBookLocationPropertiesFromBackendData
 * @param {Object} epubLocationHistoryData - payload of location history data from the backend
 * @returns {Object} object with a timestamp, documentIndex, and cfi
 *                   or null if epubLocationHistoryData or its lastModified property are unavailable
 */
const getBookLocationPropertiesFromBackendData = (epubLocationHistoryData) => {
  if (
    !epubLocationHistoryData?.epub ||
    !epubLocationHistoryData?.lastModified
  ) {
    return null;
  }

  return {
    timestamp: +new Date(epubLocationHistoryData?.lastModified),
    documentIndex: epubLocationHistoryData.documentIndex ?? 0,
    cfi: epubLocationHistoryData.cfi ?? undefined,
  };
};

export default getBookLocationPropertiesFromBackendData;
